import React from 'react';
import { IMaskMixin } from 'react-imask';
import Input from '../Input';
import MaskedInputProps from './MaskedInput.types';

const withMask = <P extends object>(
  Component: React.ComponentType<P>
  // We need to find a way to make an union type with P and IMaskInputProps
): React.ComponentType<any> =>
  IMaskMixin(({ componentDefaultValue, ...props }: any) => <Component value={componentDefaultValue} {...props} />);

const MaskedTextField = withMask(Input);

const MaskedInput = ({
  dataCy = 'maskedInput',
  dataPointer,
  defaultValue = '',
  placeholder,
  onChange,
  id,
  invalid,
  label,
  mask,
  className,
}: MaskedInputProps) => {
  const handleAccept = (value) => {
    onChange({ dataPointer, value });
  };

  return (
    <MaskedTextField
      dataCy={dataCy}
      placeholder={placeholder}
      data-pointer={dataPointer}
      id={id}
      invalid={invalid}
      className={className}
      label={label}
      mask={mask}
      onAccept={handleAccept}
      componentDefaultValue={defaultValue}
    />
  );
};

export default MaskedInput;
